import { createAsyncThunk } from '@reduxjs/toolkit';
import { actionTypes } from 'src/redesign/features/SelectedSite/store/constants';
import {
  fetchSelectedSiteApi,
  fetchSideByIdApi,
} from 'src/redesign/features/SelectedSite/store/api';

export const getSelectedSite = createAsyncThunk(
  actionTypes.GET_SELECTED_SITE,
  async () => await fetchSelectedSiteApi()
);
export const fetchSiteDataById = createAsyncThunk(
  actionTypes.FETCH_SITE_BY_ID,
  async (siteId: string) => await fetchSideByIdApi(siteId)
);
